import axios from 'axios';

function initialisePayload() {
  return {
    donationProductDetails: null,
    donationSource: 'Phone call',
    countryCode: 'AU',
    donationMinAmount: null,
    addressFullLine: null,
    sendReceiptToEmail: false,
    sendReceiptToPost: false,
    paymentCaptureSystem: 'web',
    supporter: {
      title: 'Mr',
      firstName: null,
      lastName: null,
      phoneNumber: null,
      email: null,
      isOptingIn: true,
      businessName: null,
      contactForBequest: false,
    },
    billingAddress: {
      unitNumber: null,
      streetNumber: null,
      streetName: null,
      suburb: null,
      postalCode: null,
      state: null,
      label: 'Home',
      country: 'Australia',
    },
    paymentInformation: {
      accountNumber: null,
      accountRouting: null,
      accountTitle: null,
      creditCardToken: null,
      creditCardHolderName: null,
    },
    transaction: {
      amount: null,
      isVerified: false,
      status: null,
      source: null,
      paymentType: null,
      provider: null,
      receiptNumber: null,
      settlementDate: null,
      rawDate: null,
      gftDate: null,
      rawResponse: null,
    },
    donation: {
      amount: null,
      dollarHandle: null,
      type: null,
      isActive: true,
      isOnBehalfOfBusiness: false,
      businessName: null,
      isGift: false,
      isOptingIn: false,
      contactForBequest: false,
      appealId: null,
      fundId: null,
      campaignId: null,
      packageCode: null,
      productId: null,
      paymentType: 'wwf_bbms',
      certificateUrl: null,
      sourceUrl: null,
      isGiftAtSameAddress: false,
    },
    gift: {
      title: null,
      firstName: null,
      lastName: null,
    },
    giftAddress: {
      unitNumber: null,
      streetNumber: null,
      streetName: null,
      suburb: null,
      postalCode: null,
      state: null,
      country: 'Australia',
    },
  };
}

const defaultState = {
  isDisplayed: false,
  addDonation: false,
  payload: initialisePayload(),
};

const actions = {
  open({ commit }) {
    commit('displayingUpdated', true);
  },
  close({ commit }) {
    commit('displayingUpdated', false);
  },
  reset({ commit }) {
    commit('resetDonation');
  },
  clearAddress({ commit }) {
    commit('clearAddress');
  },
  updateAddress({ commit }) {
    commit('updateAddress');
  },
  clearGiftDetails({ commit }) {
    commit('clearGiftDetails');
  },
  clearGiftAddress({ commit }) {
    commit('clearGiftAddress');
  },
  updateGiftAddress({ commit }) {
    commit('updateGiftAddress');
  },
  createDonation(state, payload) {
    console.log('payload', payload);
    return axios.post(`/donations-over-the-phone`, payload)
      .then(({ data }) => (data))
      .catch((err) => { throw err; });
  },
  getDonation(state, donationId) {
    return axios.get(`/donations-over-the-phone?donationId=${donationId}`)
      .then(({ data }) => (data))
      .catch((err) => { throw err; });
  },
  resendToken(state, webDonationId) {
    return axios.post('/donations-over-the-phone/sms/resend', { webDonationId })
      .then(({ data }) => (data))
      .catch((err) => { throw err; });
  },
  sendReceiptEmail(state, payload) {
    return axios.post('/donations-over-the-phone/emails/receipt', payload)
      .then(({ data }) => (data))
      .catch((err) => { throw err; });
  },
  getProducts() {
    return axios.get('/donations-over-the-phone/products')
      .then(({ data }) => (data))
      .catch((err) => { throw err; });
  },
  createDonationAndProcessPayment(state, payload) {
    return axios.post('/donations-over-the-phone/create-and-process-payment', payload)
      .then(({ data }) => (data))
      .catch((err) => { throw err; });
  }
};

const mutations = {
  displayingUpdated: (state, isDisplayed) => {
    state.isDisplayed = isDisplayed;
  },
  updateAddDonation: (state, addDonation) => {
    state.addDonation = addDonation;
  },
  resetDonation: (state) => {
    state.payload = initialisePayload();
  },
  clearAddress: (state) => {
    state.payload.addressFullLine = null;
    state.payload.billingAddress = {
      ...state.payload.billingAddress,
      unitNumber: null,
      streetNumber: null,
      streetName: null,
      suburb: null,
      postalCode: null,
      state: null,
    };
  },
  clearGiftDetails: (state) => {
    state.payload.donation.isGiftAtSameAddress = false;
    state.payload.gift = {
      title: null,
      firstName: null,
      lastName: null,
    };
    state.payload.giftAddress = {
      unitNumber: null,
      streetNumber: null,
      streetName: null,
      suburb: null,
      postalCode: null,
      state: null,
      country: 'Australia',
    };
  },
  clearGiftAddress: (state) => {
    state.payload.giftAddress = {
      ...state.payload.giftAddress,
      unitNumber: null,
      streetNumber: null,
      streetName: null,
      suburb: null,
      postalCode: null,
      state: null,
    };
  },
  updateGiftAddress: (state) => {
    const address = state.payload.giftAddress;
    state.payload.giftAddress = {
      ...state.payload.giftAddress,
      unitNumber: address.unitNumber && address.unitNumber.trim() !== '' ? address.unitNumber.trim() : null,
      streetNumber: address.streetNumber ? address.streetNumber.trim() : null,
      streetName: address.streetName ? address.streetName.trim() : null,
      suburb: address.suburb ? address.suburb.trim() : null,
      postalCode: address.postalCode ? address.postalCode.trim() : null,
      state: address.state ? address.state.trim() : null,
    };
  },
  updateAddress: (state) => {
    const address = state.payload.billingAddress;
    state.payload.billingAddress = {
      ...state.payload.billingAddress,
      unitNumber: address.unitNumber && address.unitNumber.trim() !== '' ? address.unitNumber.trim() : null,
      streetNumber: address.streetNumber ? address.streetNumber.trim() : null,
      streetName: address.streetName ? address.streetName.trim() : null,
      suburb: address.suburb ? address.suburb.trim() : null,
      postalCode: address.postalCode ? address.postalCode.trim() : null,
      state: address.state ? address.state.trim() : null,
    };
    state.payload.addressFullLine = `${address.unitNumber ? address.unitNumber + ', ' : ''}${address.streetNumber} ${address.streetName
      }, ${address.suburb} ${address.state} ${address.postalCode}, ${address.country}`;
  },
};

const getters = {
  isDisplayed: (state) => state.isDisplayed,
  payload: (state) => state.payload,
  addDonation: (state) => state.addDonation,
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
